import { type InboxRealtimeEvent, REALTIME_PATH } from '@dnx/contracts';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { inboxKeys } from './queries.js';

/**
 * Conecta ao tempo real do inbox (cookie da sessão, mesma origem). Eventos só trazem IDs:
 * invalidamos as queries afetadas e o conteúdo vem da API. Reconecta ao trocar de clínica.
 */
export function useInboxRealtime(organizationId: string | null) {
  const qc = useQueryClient();
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!organizationId) return;
    const socket = io({ path: REALTIME_PATH, transports: ['websocket'], withCredentials: true });
    socket.on('connect', () => setConnected(true));
    socket.on('disconnect', () => setConnected(false));
    socket.on('inbox', (e: InboxRealtimeEvent) => {
      if (e.type === 'lead.updated') { void qc.invalidateQueries({ queryKey: ['crm'] }); return; }
      if (e.type === 'appointment.updated') { void qc.invalidateQueries({ queryKey: ['scheduling'] }); return; }
      if (e.type === 'postop.alert') { void qc.invalidateQueries({ queryKey: ['postop'] }); return; }
      void qc.invalidateQueries({ queryKey: ['inbox', 'list'] });
      void qc.invalidateQueries({ queryKey: inboxKeys.counts });
      void qc.invalidateQueries({ queryKey: inboxKeys.conversation(e.conversationId) });
      if (e.type !== 'conversation.updated') void qc.invalidateQueries({ queryKey: inboxKeys.messages(e.conversationId) });
    });
    return () => { socket.close(); setConnected(false); };
  }, [organizationId, qc]);

  return connected;
}
